import {getQueryString} from "../../util/tools"
/**
 * 通用配置
 */
const state = {
  functionCode: getQueryString("FunctionCode"),
  topNavActive:"",
  secondActive:"",
  appMenus:[],
  systemConfig:{},
  functionArr:[],
  relationId:"",
  lever0Id:"",
  lever1Id:"",
  activeNode: '',
  openNode: [],
  desktopConfig:{
    firstPageIsShowAlarmMsg: false,
    menuMode: "top"
  }
}

const actions = {
  setDesktopConfig({ commit }, res) {
    commit("setDesktopConfig", res);
  },
  setLever0Id({ commit }, res) {
    commit("setLever0Id", res);
  },
  setLever1Id({ commit }, res) {
    commit("setLever1Id", res);
  },
  setRelationId({ commit }, res) {
    commit("setRelationId", res);
  },
  setTopNavActive({ commit }, res) {
    commit("setTopNavActive", res);
  },
  setSecondActive({ commit }, res) {
    commit("setSecondActive", res);
  },
  setAppMenus({ commit }, res) {
    commit("setAppMenus", res);
  },
  setSystemConfig({ commit }, res) {
    commit("setSystemConfig", res);
  },
  setFunctionArr({ commit }, res) {
    commit("setFunctionArr", res);
  },
  setActiveNode ({ commit }, res) {
    commit('setActiveNode', res)
  },
  setOpenNode ({ commit }, res) {
    commit('setOpenNode', res)
  },
}

const getters = {
  getTopNavActive:(state)=>state.topNavActive,
  getRelationId:(state)=>state.relationId,
  getLever0Id:(state)=>state.lever0Id,
  getLever1Id:(state)=>state.lever1Id,
  getActiveNode: (state) => state.activeNode,
  getOpenNode: (state) => state.openNode,
  getDesktopConfig: (state) => state.desktopConfig,
}

const mutations = {
  setDesktopConfig(state, res) {
    state.desktopConfig = res;
  },
  setLever0Id(state, res) {
    state.lever0Id = res;
  },
  setLever1Id(state, res) {
    state.lever1Id = res;
  },
  setRelationId(state, res) {
    state.relationId = res;
  },
  setTopNavActive(state, res) {
    state.topNavActive = res;
  },
  setSecondActive(state, res) {
    state.secondActive = res;
  },
  setAppMenus(state, res) {
    state.appMenus = res;
  },
  setSystemConfig(state, res) {
    state.systemConfig = res;
  },
  setFunctionArr(state,res){
    state.functionArr = res;
  },
  setActiveNode (state, res) {
    state.activeNode = res
  },
  setOpenNode (state, res) {
    state.openNode = res
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/com.js